export default {
	SubmitDeclaration: 'Nộp tờ khai',
	AddTaxPaper: 'Lập giấy nộp tiền',
	AddTaxPaperNowAcronym: 'Lập giấy nộp tiền nộp thay',
	Later: 'Để sau',
	VerifyButton: 'Xác thực',
	Cancel: 'Hủy bỏ',
	Confirm: 'Xác nhận',
	User: {
		ListTaxCode: 'Danh sách mã số thuế',
		Change: 'Thay đổi',
		UsageAgreement: 'Thỏa thuận sử dụng phần mềm',
		PrivacyPolicy: 'Chính sách bảo vệ dữ liệu cá nhân',
		LogOut: 'Đăng xuất',
		Update: 'Thông tin tài khoản',
		SatisfactionAssessment: 'Đánh giá độ hài lòng'
	},
	Verify: {
		AccuracyInfo: 'Xác thực thông tin',
		InputVerifyHasSend: type =>
			`Nhập mã xác thực đã được gửi đến ${type == 2 ? 'số điện thoại' : 'email'
			}`,
		NotMyUser: type =>
			`Đây không phải là ${type == 2 ? 'số điện thoại' : 'email'
			} của tôi`,
		VerifyCode: 'Mã xác thực',
		NotTakeCode: 'Không nhận được mã?',
		Resend: 'Gửi lại',
		PhoneNoneActive: 'Số điện thoại chưa xác thực',
		ActiveToLogin: (type, value) =>
			`Xác thực ngay để đăng nhập bằng ${type == 2 ? 'số điện thoại' : 'email'
			} <strong>${value}</strong> từ lần sau`,
		EmailNoneActive: 'Email chưa xác thực'
	},
	Notification: 'Thông báo',
	ActivatedAccount: '[Kích hoạt]',
	RequiredCode: 'Mã xác thực không được để trống',
	AdviseUse: 'Tư vấn sử dụng'
};
